<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="600">
    <v-card>
      <v-card-title class="headline">
        <v-icon left color="primary">mdi-restore</v-icon>
        Reactivate Your Subscription
      </v-card-title>

      <v-card-text>
        <v-alert
          :type="isExpired ? 'warning' : 'info'"
          dense
          class="mb-4"
        >
          <div v-if="!isExpired">
            Your subscription is scheduled to end on <strong>{{ formattedEndDate }}</strong>.
          </div>
          <div v-else>
            Your subscription expired on <strong>{{ formattedEndDate }}</strong>.
          </div>
        </v-alert>

        <p class="subtitle-1 mb-3">Choose a plan to reactivate:</p>

        <v-radio-group
          :value="reactivationPlan"
          @change="$emit('update:plan', $event)"
          class="mt-0"
        >
          <v-radio value="pro">
            <template v-slot:label>
              <div class="d-flex align-center">
                <div class="flex-grow-1">
                  <div class="font-weight-medium">
                    <v-icon small>mdi-star-three-points-outline</v-icon>
                    Pro Plan
                  </div>
                  <div class="text-caption">Individual features and capabilities</div>
                </div>
                <div class="pricing-badge">
                  <span class="price">$99</span>
                  <span class="period">/month</span>
                </div>
              </div>
            </template>
          </v-radio>

          <v-radio value="team_pro" class="mt-3">
            <template v-slot:label>
              <div class="d-flex align-center">
                <div class="flex-grow-1">
                  <div class="font-weight-medium">
                    <v-icon small>mdi-account-group</v-icon>
                    Pro Team Plan
                  </div>
                  <div class="text-caption">All Pro features plus team collaboration</div>
                  <div class="text-caption text-success">
                    <v-icon x-small color="success">mdi-account-multiple</v-icon>
                    Includes 5 team members
                  </div>
                </div>
                <div class="pricing-badge">
                  <span class="price">$299</span>
                  <span class="period">/month</span>
                </div>
              </div>
            </template>
          </v-radio>
        </v-radio-group>

        <v-divider class="my-4"></v-divider>

        <div class="text-body-2">
          <div v-if="isExpired">
            <p>
              <v-icon small color="warning">mdi-alert</v-icon>
              Since your subscription has expired, you'll be redirected to create a new subscription.
            </p>
          </div>
          <div v-else>
            <p>
              <v-icon small color="success">mdi-check-circle</v-icon>
              Reactivating before {{ formattedEndDate }} will restore your access immediately.
            </p>
          </div>
          <p>
            <v-icon small>mdi-credit-card</v-icon>
            You'll be charged the regular monthly rate for your selected plan.
          </p>
          <p>
            <v-icon small>mdi-shield-check</v-icon>
            Secure payment processing. Cancel anytime from your account settings.
          </p>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text
          @click="$emit('input', false)"
          :disabled="loading"
        >
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          @click="$emit('confirm')"
          :loading="loading"
        >
          <span class="black--text">{{ isExpired ? 'Create New Subscription' : 'Reactivate' }}</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ReactivationDialog',

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    reactivationPlan: {
      type: String,
      default: 'pro',
    },
    subscriptionEndDate: {
      type: String,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    isExpired() {
      if (!this.subscriptionEndDate) return false;
      return new Date(this.subscriptionEndDate) < new Date();
    },

    formattedEndDate() {
      if (!this.subscriptionEndDate) return '';
      return new Date(this.subscriptionEndDate).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    },
  },
};
</script>

<style scoped>
.pricing-badge {
  display: inline-block;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  padding: 4px 8px;
  text-align: center;
  min-width: 90px;
}

.pricing-badge .price {
  font-weight: bold;
  font-size: 1.1rem;
  color: #1976d2;
}

.pricing-badge .period {
  font-size: 0.8rem;
}
</style>
